var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"slider"},[_c('SplitPages'),_c('Hide'),_c('Zoom'),_c('Delete'),_c('div',{staticClass:"slider__mainBox"},[_c('MainPhoto'),_c('Arrows'),_c('Counter')],1),_c('Thumbs'),_c('LastButtons')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }